<script>
import Layout from "@/views/layouts/default";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import moment from "moment";

import {
  required,
  minLength,
} from "vuelidate/lib/validators";


export default {
  name: "ArmadaFormEdit",
  page: {
    title: "Edit Armada",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, DatePicker },
  data() {
    return {
      title: "Edit Armada",
      items: [
        {
          text: "Manajemen Armada",
        },
        {
          text: "Armada",
          href: "/truck"
        },
        {
          text: "Edit",
          active: true
        },
      ],
      form: { 
        vehicle_category_id: null,
        stnk_path: null,
        stnk_number: "",
        plat_number: "",
        merk: "",
        model: "",
        color: "",
        stnk_expired_at: "",
        kir_path: null,
        kir_number: "",
        kir_expired_at: "",
        width: "",
        height: "",
        length: "",
        volume: "",
        tonase: "",
        photos: []
      },
      categories: [],
      error: {
        stnk: false,
        kir: false,
        photo: false
      },
      isSubmitArmadaError: false,
      errorMessage: null,
      isSubmitArmadaSuccess: false,
      successMessage: null,
    };
  },
  validations: {
    form: {
      vehicle_category_id: { required },
      stnk_number: { required, minLength: minLength(7) },
      plat_number: { required, minLength: minLength(7) },
      merk: { required },
      model: { required },
      color: { required },
      stnk_expired_at: { required },
      kir_number: { required, minLength: minLength(7) },
      kir_expired_at: { required },
      width: { required },
      height: { required },
      length: { required },
      volume: { required },
      tonase: { required },
    }
  },
  created() {
    this.getCategories()
    this.getDetailArmada()
  },
  computed: {
    photoDepan() {
      const depan = this.form.photos.find(item => item.position === 'depan')
      if (depan !== undefined) {
        return depan.path
      } else {
        return null
      }
    },
    photoBelakang() {
      const belakang = this.form.photos.find(item => item.position === 'belakang')
      if (belakang !== undefined) {
        return belakang.path
      } else {
        return null
      }
    },
    photoKiri() {
      const kiri = this.form.photos.find(item => item.position === 'kiri')
      if (kiri !== undefined) {
        return kiri.path
      } else {
        return null
      }
    },
    photoKanan() {
      const kanan = this.form.photos.find(item => item.position === 'kanan')
      if (kanan !== undefined) {
        return kanan.path
      } else {
        return null
      }
    }
  },
  methods: {
    getDetailArmada() {
      this.$axios.get(`/v1/logistic_company/armada/${this.$route.params.id}`)
        .then(response => {
          const armada = response.data.data
          this.form = { 
            vehicle_category_id: armada.vehicle_category_id.toString(),
            stnk_path: armada.stnk_path,
            stnk_number: armada.stnk_number,
            plat_number: armada.plat_number,
            merk: armada.merk,
            model: armada.model,
            color: armada.color,
            stnk_expired_at: moment(armada.stnk_expired_at).format('YYYY-MM-DD'),
            kir_path: armada.kir_path,
            kir_number: armada.kir_number,
            kir_expired_at: moment(armada.kir_expired_at).format('YYYY-MM-DD'),
            width: armada.width,
            height: armada.height,
            length: armada.length,
            volume: armada.volume,
            tonase: armada.tonase,
            photos: armada.photos
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            this.$router.push('/404')
          }
        })
    },
    getCategories() {
      this.$axios.get('/v1/armada_category', {
        params: {
          page: 1,
          per_page: 100,
          orderby: 'name',
          sort: 'asc',
          status: 'aktif'
        }
      })
        .then(response => {
          this.categories = response.data.data.rows.map(item => {
            return { value: item.id.toString(), text: item.name }
          })
          this.categories.unshift({ value: null, text: 'Pilih Kategori Armada' })
        })
    },
    updateArmada() {
      if (this.form.stnk_path === null) {
        this.error.stnk = true;
      } 
      if (this.form.kir_path === null) {
        this.error.kir = true;
      } 
      if (this.form.photos.length === 0) {
        this.error.photo = true;
      }

      this.$v.$touch();

      if (!this.$v.$invalid && !this.error.stnk && !this.error.kir && !this.error.photo) {
        window.scrollTo(0,0);
        this.$axios.put(`/v1/logistic_company/armada/${this.$route.params.id}`, this.form)
          .then(response => {
            this.isSubmitArmadaSuccess = true
            this.isSubmitArmadaError = false
            this.successMessage = response.data.message
            setTimeout(() => {
              this.$router.push('/truck')
            }, 3000)
          }).catch(error => {
            this.isSubmitArmadaSuccess = false
            this.isSubmitArmadaError = true
            this.errorMessage = error.response.data.message
          })
      }
    },
    uploadDocument(event) {
      if(event.target.files[0] !== undefined){
        let extension = event.target.files[0].name.split(".").pop()
        let allowedExtention = ['jpg','jpeg','png','pdf']
        if(allowedExtention.includes(extension.toLowerCase())){
          let param = new FormData();
          param.append('file', event.target.files[0])
          param.append('status', 'active') 
          param.append('title', event.target.name)
          param.append('description', 'armada')

          this.$axios.post('/v1/admin/media', param)
            .then(response => {
              if (event.target.name === 'upload_stnk') {
                this.form.stnk_path = response.data.data.file
                this.error.stnk = false
              } else if (event.target.name === 'upload_kir') {
                this.form.kir_path = response.data.data.file
                this.error.kir = false
              } else if (event.target.name === 'upload_photo_depan') {
                const depan = this.form.photos.findIndex(item => item.position === 'depan')
                if (depan < 0) {
                  this.form.photos.push({
                    position: 'depan',
                    path: response.data.data.file
                  })
                } else {
                  this.form.photos[depan].path = response.data.data.file
                }
                this.error.photo = false
              } else if (event.target.name === 'upload_photo_belakang') {
                const belakang = this.form.photos.findIndex(item => item.position === 'belakang')
                if (belakang < 0) {
                  this.form.photos.push({
                    position: 'belakang',
                    path: response.data.data.file
                  })
                } else {
                  this.form.photos[belakang].path = response.data.data.file
                }
                this.error.photo = false
              } else if (event.target.name === 'upload_photo_kiri') {
                const kiri = this.form.photos.findIndex(item => item.position === 'kiri')
                if (kiri < 0) {
                  this.form.photos.push({
                    position: 'kiri',
                    path: response.data.data.file
                  })
                } else {
                  this.form.photos[kiri].path = response.data.data.file
                }
                this.error.photo = false
              } else if (event.target.name === 'upload_photo_kanan') {
                const kanan = this.form.photos.findIndex(item => item.position === 'kanan')
                if (kanan < 0) {
                  this.form.photos.push({
                    position: 'kanan',
                    path: response.data.data.file
                  })
                } else {
                  this.form.photos[kanan].path = response.data.data.file
                }
                this.error.photo = false
              } 
            })

        }else{
          this.isSubmitArmadaError = true
          this.errorMessage = "image extentions not allowed"
        }
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <b-form @submit.prevent="updateArmada" class="form-horizontal">
          <div class="card">
            <div class="card-body">
              <b-alert
                v-model="isSubmitArmadaSuccess"
                class="mt-3"
                variant="success"
                dismissible
              >{{ successMessage }}</b-alert>

              <b-alert
                v-model="isSubmitArmadaError"
                class="mt-3"
                variant="danger"
                dismissible
              >{{errorMessage}}</b-alert>

              <div class="row">
                <div class="col-lg-4">
                  <h5 class="font-weight-semibold">Data STNK</h5>
                  <b-button variant="outline-danger" type="button" class="w-100 mb-1 is-invalid" @click.prevent="$refs.updateStnk.click()">Upload STNK</b-button>
                  <div v-if="error.stnk" class="invalid-feedback">
                    <span>{{ $t('form.validation.required', { field: 'STNK' }) }}</span>
                  </div>
                  <input type="file" name="upload_stnk" ref="updateStnk" @change="uploadDocument" />
                  <img v-if="form.stnk_path" :src="form.stnk_path" alt="200x200" class="img-thumbnail w-100 mb-3" />

                  <b-form-group id="stnk-group" label="No STNK" label-for="stnk">
                    <b-form-input
                      id="stnk"
                      name="stnk"
                      v-model.trim="form.stnk_number"
                      :class="{ 'is-invalid': $v.form.stnk_number.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.stnk_number.$error" class="invalid-feedback">
                      <span v-if="!$v.form.stnk_number.required">{{ $t('form.validation.required', { field: 'No STNK' }) }}</span>
                      <span v-if="!$v.form.stnk_number.minLength">{{ $t('form.validation.min_length', { field: 'No STNK', length: 7 }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="plat-group" label="No Plat" label-for="plat">
                    <b-form-input
                      id="plat"
                      name="plat"
                      v-model.trim="form.plat_number"
                      :class="{ 'is-invalid': $v.form.plat_number.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.plat_number.$error" class="invalid-feedback">
                      <span v-if="!$v.form.plat_number.required">{{ $t('form.validation.required', { field: 'No Plat' }) }}</span>
                      <span v-if="!$v.form.plat_number.minLength">{{ $t('form.validation.min_length', { field: 'No Plat', length: 7 }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="tipe-group" label="Tipe" label-for="tipe">
                    <b-form-select
                      id="tipe"
                      name="tipe"
                      v-model.trim="form.vehicle_category_id"
                      :options="categories"
                      :class="{ 'is-invalid': $v.form.vehicle_category_id.$error }"
                    ></b-form-select>
                    <div v-if="$v.form.vehicle_category_id.$error" class="invalid-feedback">
                      <span v-if="!$v.form.vehicle_category_id.required">{{ $t('form.validation.required', { field: 'Tipe' }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="merk-group" label="Merk" label-for="merk">
                    <b-form-input
                      id="merk"
                      name="merk"
                      v-model.trim="form.merk"
                      :class="{ 'is-invalid': $v.form.merk.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.merk.$error" class="invalid-feedback">
                      <span v-if="!$v.form.merk.required">{{ $t('form.validation.required', { field: 'Merk' }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="model-group" label="Model" label-for="model">
                    <b-form-input
                      id="model"
                      name="model"
                      v-model.trim="form.model"
                      :class="{ 'is-invalid': $v.form.model.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.model.$error" class="invalid-feedback">
                      <span v-if="!$v.form.model.required">{{ $t('form.validation.required', { field: 'Model' }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="warna-group" label="Warna" label-for="warna">
                    <b-form-input
                      id="warna"
                      name="warna"
                      v-model.trim="form.color"
                      :class="{ 'is-invalid': $v.form.color.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.color.$error" class="invalid-feedback">
                      <span v-if="!$v.form.color.required">{{ $t('form.validation.required', { field: 'Warna' }) }}</span>
                    </div>
                  </b-form-group>

                   <b-form-group id="masaActiveSim-group" label="Masa Aktif" label-for="masaActiveSim">
                    <date-picker
                      id="stnk_expired_at"
                      name="stnk_expired_at"
                      :class="{ 'is-invalid': $v.form.stnk_expired_at.$error }"
                      v-model="form.stnk_expired_at"
                      :disabled-date="notBeforeToday"
                      :first-day-of-week="1"
                      format="DD MMMM YYYY"
                      value-type="YYYY-MM-DD"
                      lang="en"
                    ></date-picker>
                    <div v-if="$v.form.stnk_expired_at.$error" class="invalid-feedback">
                      <span v-if="!$v.form.stnk_expired_at.required">{{ $t('form.validation.required', { field: 'Masa Aktif' }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4 border-kiri">
                  <h5 class="font-weight-semibold">Data KIR</h5>
                  <b-button variant="outline-danger" type="button" class="w-100 mb-1 is-invalid" @click="$refs.updateKir.click()">Upload KIR</b-button>
                  <div v-if="error.kir" class="invalid-feedback">
                    <span>{{ $t('form.validation.required', { field: 'KIR' }) }}</span>
                  </div>
                  <input type="file" name="upload_kir" ref="updateKir" @change="uploadDocument" />
                  <img v-if="form.kir_path" :src="form.kir_path" alt="200x200" class="img-thumbnail w-100 mb-3" />

                  <b-form-group id="sim-group" label="No KIR" label-for="sim">
                    <b-form-input
                      id="kir"
                      v-model.trim="form.kir_number"
                      :class="{ 'is-invalid': $v.form.kir_number.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.kir_number.$error" class="invalid-feedback">
                      <span v-if="!$v.form.kir_number.required">{{ $t('form.validation.required', { field: 'No KIR' }) }}</span>
                      <span v-if="!$v.form.kir_number.minLength">{{ $t('form.validation.min_length', { field: 'No KIR', length: 7 }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="nameSim-group" label="Masa Aktif" label-for="nameSim">
                    <date-picker
                      id="kir_expired_at"
                      name="kir_expired_at"
                      :class="{ 'is-invalid': $v.form.kir_expired_at.$error }"
                      v-model="form.kir_expired_at"
                      :disabled-date="notBeforeToday"
                      :first-day-of-week="1"
                      format="DD MMMM YYYY"
                      value-type="YYYY-MM-DD"
                      lang="en"
                    ></date-picker>
                    <div v-if="$v.form.kir_expired_at.$error" class="invalid-feedback">
                      <span v-if="!$v.form.kir_expired_at.required">{{ $t('form.validation.required', { field: 'Masa Aktif' }) }}</span>
                    </div>
                  </b-form-group>

                  <div class="form-group row">
                    <div class="col-sm-4">
                      <b-form-group id="length-group" label="Panjang" label-for="length">
                        <b-form-input
                          id="length"
                          name="length"
                          v-model.trim="form.length"
                          :class="{ 'is-invalid': $v.form.length.$error }"
                          type="number"
                        ></b-form-input>
                        <div v-if="$v.form.length.$error" class="invalid-feedback">
                          <span v-if="!$v.form.length.required">{{ $t('form.validation.required', { field: 'Panjang' }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4">
                      <b-form-group id="width-group" label="Lebar" label-for="width">
                        <b-form-input
                          id="width"
                          name="height"
                          v-model.trim="form.width"
                          :class="{ 'is-invalid': $v.form.width.$error }"
                          type="number"
                        ></b-form-input>
                        <div v-if="$v.form.width.$error" class="invalid-feedback">
                          <span v-if="!$v.form.width.required">{{ $t('form.validation.required', { field: 'Lebar' }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-sm-4">
                      <b-form-group id="height-group" label="Tinggi" label-for="height">
                        <b-form-input
                          id="height"
                          name="height"
                          v-model.trim="form.height"
                          :class="{ 'is-invalid': $v.form.height.$error }"
                          type="number"
                        ></b-form-input>
                        <div v-if="$v.form.height.$error" class="invalid-feedback">
                          <span v-if="!$v.form.height.required">{{ $t('form.validation.required', { field: 'Tinggi' }) }}</span>
                        </div>
                      </b-form-group>
                    </div>
                  </div>

                  <b-form-group id="volume-group" label="Volume Box" label-for="volume">
                    <b-form-input
                      id="volume"
                      name="volume"
                      v-model.trim="form.volume"
                      :class="{ 'is-invalid': $v.form.volume.$error }"
                      type="number"
                    ></b-form-input>
                    <div v-if="$v.form.volume.$error" class="invalid-feedback">
                      <span v-if="!$v.form.volume.required">{{ $t('form.validation.required', { field: 'Volume Box' }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group id="tonase-group" label="Tonase" label-for="tonase">
                    <b-form-input
                      id="tonase"
                      name="tonase"
                      v-model.trim="form.tonase"
                      :class="{ 'is-invalid': $v.form.tonase.$error }"
                      type="number"
                    ></b-form-input>
                    <div v-if="$v.form.tonase.$error" class="invalid-feedback">
                      <span v-if="!$v.form.tonase.required">{{ $t('form.validation.required', { field: 'Tonase' }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4 border-kiri pl-4">
                  <h5 class="font-weight-semibold is-invalid">Foto</h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <div v-if="!photoDepan" ref="photoDepan" @click="$refs.uploadPhotoDepan.click()" class="py-4 border-radius text-center font-size-18 text-weight-bolder cursor-pointer">Depan</div>
                      <img v-if="photoDepan" :src="photoDepan" @click="$refs.uploadPhotoDepan.click()" alt="200x200" class="img-thumbnail w-100 mb-3" />
                      <input type="file" name="upload_photo_depan" ref="uploadPhotoDepan" @change="uploadDocument" />
                    </div>
                    <div class="col-lg-6">
                      <div v-if="!photoBelakang" ref="photoBelakang" @click="$refs.uploadPhotoBelakang.click()" class="py-4 border-radius text-center font-size-18 text-weight-bolder cursor-pointer">Belakang</div>
                      <img v-if="photoBelakang" :src="photoBelakang" @click="$refs.uploadPhotoBelakang.click()" alt="200x200" class="img-thumbnail w-100 mb-3" />
                      <input type="file" name="upload_photo_belakang" ref="uploadPhotoBelakang" @change="uploadDocument" />
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-6">
                      <div v-if="!photoKiri" ref="photoKiri" @click="$refs.uploadPhotoKiri.click()" class="py-4 border-radius text-center font-size-18 text-weight-bolder cursor-pointer">Kiri</div>
                      <img v-if="photoKiri" :src="photoKiri" @click="$refs.uploadPhotoKiri.click()" alt="200x200" class="img-thumbnail w-100 mb-3" />
                      <input type="file" name="upload_photo_kiri" ref="uploadPhotoKiri" @change="uploadDocument" />
                    </div>
                    <div class="col-lg-6">
                      <div v-if="!photoKanan" ref="photoKanan" @click="$refs.uploadPhotoKanan.click()" class="py-4 border-radius text-center font-size-18 text-weight-bolder cursor-pointer">Kanan</div>
                      <img v-if="photoKanan" :src="photoKanan" @click="$refs.uploadPhotoKanan.click()" alt="200x200" class="img-thumbnail w-100 mb-3" />
                      <input type="file" name="upload_photo_kanan" ref="uploadPhotoKanan" @change="uploadDocument" />
                    </div>
                  </div>
                  <div v-if="error.photo" class="invalid-feedback">
                    <span>{{ $t('form.validation.required', { field: 'Photo' }) }}</span>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm-2">
                  <b-button to="/truck" type="button" class="w-100 btn-light">Kembali</b-button>
                </div>
                <div class="col-sm-2">
                  <b-button type="submit" variant="danger" class="w-100">Simpan</b-button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
input[type=file] {
  visibility: hidden;
}
</style>